import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import FilterLink from '../../../components/filter/FilterLink'
import GroupPickerModal from './GroupPickerModal'

const GroupPicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation(['listGroups', 'common'])
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiTeamLine'}
        label={label || t('listGroups:group')}
        value={compactString(value, { t: t, tField: 'groupIds' })}
        onClick={() => setOpen(true)}
      />
      <GroupPickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default GroupPicker
